import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { Search } from 'styled-icons/material';
import { PopUpView, Select as Filter } from '~/components';
import Picker from '~/components/Filter/Picker';
import Button from '~/components/Button';
import Icon from '~/components/Icon';
import DatesSlider from '~/components/DatesSlider';
import * as S from '../styles';
import { propTypes } from './propsValidation';

export default function DashboardFilters({
  clubs,
  competitions,
  seasons,
  dates,
  stadiums,
  carouselDates,
  sliderRef,
  getSlideRef,
  resetFilters,
  clubFilter,
  competitionFilter,
  seasonFilter,
  dateFilter,
  stadiumFilter,
  carouselDatesFilter,
  setClubFilter,
  setCompetitionFilter,
  setSeasonFilter,
  setDateFilter,
  setStadiumFilter,
  setCarouselDatesFilter,
  currentSlide,
  setCurrentSlide,
}) {
  const { t } = useTranslation();
  const [showModal, setModalVisibility] = useState(false);

  return (
    <S.FilterBar>
      <S.ShowFilters onClick={() => setModalVisibility(!showModal)}>
        {t('showFilters')}
      </S.ShowFilters>
      <DatesSlider
        options={carouselDates.data.gameweeks}
        isLoading={carouselDates.loading}
        getSlideRef={getSlideRef}
        selectedDate={carouselDatesFilter}
        setCarouselDatesFilter={setCarouselDatesFilter}
        sliderRef={sliderRef}
        currentSlide={currentSlide}
        setCurrentSlide={setCurrentSlide}
        slidesToShow={clubFilter || seasonFilter || stadiumFilter ? 6 : 9}
        setDateFilter={setDateFilter}
      />
      <PopUpView
        isOpen={showModal}
        onClose={() => setModalVisibility(false)}
        zone="left"
        fullWidth
      >
        <S.FilterContainer>
          <S.FilterTitle>
            {t('filters')}
            <div
              role="button"
              className="link"
              tabIndex={0}
              onClick={() => setModalVisibility(false)}
              onKeyDown={() => setModalVisibility(false)}
            >
              <Icon name="close" size={14} color="black" />
            </div>
          </S.FilterTitle>

          <Filter
            selector="season"
            label={t('season')}
            value={seasonFilter}
            onChange={setSeasonFilter}
            options={seasons.data}
            placeholder={t('allFemale')}
            isLoading={seasons.loading}
            getOptionValue={option => option.id}
            getOptionLabel={option => option.season}
          />

          <Filter
            selector="competition"
            label={t('competition')}
            value={competitionFilter}
            onChange={setCompetitionFilter}
            options={competitions.data}
            placeholder={t('allFemale')}
            isLoading={competitions.loading}
            minWidth={300}
            getOptionValue={option => option.id}
            getOptionLabel={option => option.name}
            isClearable
          />

          <Filter
            selector="club"
            label={t('club')}
            value={clubFilter}
            onChange={setClubFilter}
            options={clubs.data}
            placeholder={t('all')}
            isLoading={clubs.loading}
            minWidth={300}
            getOptionValue={option => option.id}
            getOptionLabel={option => option.nickname}
            isClearable
          />

          <Filter
            selector="stadium"
            label={t('stadium')}
            value={stadiumFilter}
            onChange={setStadiumFilter}
            options={stadiums.data}
            noBorder
            placeholder={t('all')}
            isLoading={stadiums.loading}
            minWidth={300}
            getOptionValue={option => option.id}
            getOptionLabel={option => option.name}
            isClearable
          />

          <Picker
            label={t('date')}
            dateFilter={dateFilter}
            setDateFilter={setDateFilter}
            options={dates}
            isLoading={carouselDates.loading}
          />

          <S.FilterButtonsContainer>
            <Button onClick={resetFilters}>
              <Icon name="reset" size={15} color="coral" />
              {t('cleanFilters')}
            </Button>
          </S.FilterButtonsContainer>
        </S.FilterContainer>
      </PopUpView>
    </S.FilterBar>
  );
}

DashboardFilters.propTypes = propTypes;
